import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { TableCell } from "@mui/material";
import CellContent from "./CellContent";
const TableBodyCell = React.memo(({ column, row }) => {
    const value = row[column.id];
    const displayValue = column.format && typeof value === "number" ? column.format(value) : value;
    return (_jsx(TableCell, Object.assign({ align: column.align, "data-label": column.label }, { children: _jsx(CellContent, { displayValue: displayValue }) }), column.id));
});
TableBodyCell.displayName = "TableBodyCell";
export default TableBodyCell;
